import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "src/Redux/Slices/AuthSlice";
import HeaderReducer from "src/Redux/Slices/HeaderSlice";
// import KeywordReducer from "src/Redux/Slices/KeywordSlice";
import BranchReducer from "src/Redux/Slices/BranchSlice";
import WoBranchSlice from "src/Redux/Slices/WoBranchSlice";
import PoBranchSlice from "src/Redux/Slices/PoBranchSlice";
import TicketSlice from "src/Redux/Slices/TicketSlice";

import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";

const woBranchPersistConfig = {
  key: "woBranch",
  storage,
};

const poBranchPersistConfig = {
  key: "poBranch",
  storage,
};

const rootReducer = combineReducers({
  Auth: AuthReducer,
  Header: HeaderReducer,
  // Keyword: KeywordReducer,
  Branch: BranchReducer,
  WoBranch: persistReducer(woBranchPersistConfig, WoBranchSlice),
  PoBranch: persistReducer(poBranchPersistConfig, PoBranchSlice),
  Ticket: TicketSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);
